const EZ = 'ez';
const HPC = 'hpc';
const CR = 'cr';
const DISABLED = 'disabled';

export { CR as C, DISABLED as D, EZ as E, HPC as H };
